import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimary from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-sofyre-ingredients';

const ingredients = [
  {
    desktopImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd331eadbe0fa3cf3b39.webp?w=1000',
    mobileImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd3a153cdc4eff9516c8.webp?w=1000',
    title: '<p>40% CONCENTRATION</p><h3>Peppermint Oil</h3>',
    tags: ['Nerve-trigger', 'Scent-Activated', 'Instinct-Driven'],
    description: "<p>Forces mice's survival instinct to fire. Instantly.</p>",
  },
  {
    desktopImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd6c5d02d9d1031b51a2.webp?w=1000',
    mobileImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd700295660e7f2b62da.webp?w=1000',
    title: '<p>5% CONCENTRATION</p><h3>Cinnamon Oil</h3>',
    tags: ['Trail-destroyer', 'Pheromone-Blocker'],
    description: "<p>Destroys their navigation system. They can't find their way in.</p>",
  },
  {
    desktopImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd9b4cb3dc0222502f23.webp?w=1000',
    mobileImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bd9f6c9ea9286d90d45b.webp?w=1000',
    title: '<p>4% CONCENTRATION</p><h3>Cedarwood Oil</h3>',
    tags: ['Nesting-Blocker', 'Territory-Stopper'],
    description: '<p>Stops nesting before it starts. Used for centuries.</p>',
  },
  {
    desktopImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bdc5f10930fbe2ffe075.webp?w=1000',
    mobileImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bdc83a66a64e44ca3612.webp?w=1000',
    title: '<p>5% CONCENTRATION</p><h3>Proprietary Complex</h3>',
    tags: ['90-Day-Potency', 'Slow-Release', 'Full-Coverage'],
    description: '<p>Keeps protection active for 90 days straight.</p>',
  },
];

const featureHtml = feature => `
  <article class="sofyre-ingredients__feature" data-attribute="sofyre-ingredients__feature">
    <picture class="sofyre-ingredients__picture">
      <source data-attribute="sofyre-ingredients__image-mobile" media="(max-width: 768px)" srcset="${
        feature.mobileImage
      }">
      <img data-attribute="sofyre-ingredients__image-desktop" src="${feature.desktopImage}" alt="" loading="lazy">
    </picture>
    <div class="sofyre-ingredients__feature-overlay" aria-hidden="true"></div>
    <div class="sofyre-ingredients__feature-content">
      <div class="sofyre-ingredients__feature-title" data-attribute="sofyre-ingredients__feature-title">${
        feature.title
      }</div>
      <div class="sofyre-ingredients__tags" data-attribute="sofyre-ingredients__tags">
        ${feature.tags
          .map(tag => `<span class="sofyre-ingredients__tag" data-attribute="sofyre-ingredients__tag">${tag}</span>`)
          .join('')}
      </div>
      <div class="sofyre-ingredients__description" data-attribute="sofyre-ingredients__description">${
        feature.description
      }</div>
    </div>
  </article>
`;

const buttonHtml = buttonPrimary({
  text: 'ADD TO CART',
  backgroundColor: '#ccf46f',
  color: '#23372b',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/09/08/image-6a9fb3c9503aaa5482a117ec.png',
  },
});

const contentHtml = `
  <div class="sofyre-ingredients container" data-attribute="sofyre-ingredients">
    <header
      class="sofyre-ingredients__header"
      data-attribute="sofyre-ingredients__header"
    >
      <h2 style="text-align: center">
        The Science of Nature
      </h2>
      <p style="text-align: center">
        Before Traps. Before Poison. Nature Already Had The Answer.
      </p>
    </header>
    <div class="sofyre-ingredients__features" data-attribute="sofyre-ingredients__features">
      ${ingredients.map(featureHtml).join('')}
    </div>
    <div class="sofyre-ingredients__cta">${buttonHtml}</div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#000000',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bcedfdef5636e92f08fd.png?w=1000',
  useBackgroundMobile: true,
  backgroundImageMobile: 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bcea569551daa844e40d.png?w=1000',
  textColor: '#F7F7F0',
  topPadding: true,
  bottomPadding: true,
});
